
import axios from 'axios';

//const BASE_URL = 'http://144.91.102.67';
const BASE_URL = 'https://eezeelearn.in/api';

{/*
export const extractText = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  try {
    const response = await fetch(`${BASE_URL}/extract`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error extracting text:", error);
    throw error;
  }
}; */}
export const extractText = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  try {
    const response = await fetch(`${BASE_URL}/extract`, {
      method: 'POST',
      body: formData
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error extracting text:", error);
    throw error;
  }
};


{/*export const getTeachSummary = async (text, filename) => {
const response = await axios.post(`${BASE_URL}/teach_summary`, {
text,
filename
});
return response.data;
};*/}

export const getTeachSummary = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  try {
    const response = await axios.post(`${BASE_URL}/teacher-summary`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Teacher summary error:", error);
    throw error;
  }
};

export const translateLesson = async (text, lang) => {
  const response = await axios.post(`${BASE_URL}/translate`, {
    text,
    target_lang: lang
  });
  return response.data;
};


export const generateAudio = async (text, lang) => {
  try {
    const response = await fetch(`${BASE_URL}/Audiogeneration`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ text, lang })
    });

    if (!response.ok) {
      throw new Error('Audio request failed');
    }

    const data = await response.json();
    //const audioUrl = URL.createObjectURL(blob);
    return data.audio_url; // Return full URL
  } catch (error) {
    console.error('Audio generation error:', error);
    throw error;
    //return null;
  }
};
// last working code 
{/*export const generateVideo = async (mode, audioPath, text = null) => {
  const formData = new FormData();
  formData.append("mode", mode); // scene or single
  formData.append("audio_path", audioPath); // e.g. static/audio/output_ta.mp3
  if (mode === "single" && text) {
    formData.append("text", text);
  }

  const response = await fetch(`${BASE_URL}/generate_video`, {
    method: 'POST',
    body: formData
  });

  if (!response.ok) {
    const errorText = await response.text(); // Helpful!
    console.error("Backend error:", errorText);
    throw new Error("Video generation failed");
  }

  const blob = await response.blob();
  return URL.createObjectURL(blob);
};*/}


// new added code on 2025-09-09 
export const generateVideo = async (mode, audioPath, text) => {
  try {
    const formData = new FormData();
    formData.append("mode", mode); // scene or single
    formData.append("audio_path", audioPath); // e.g. static/audio/output_ta.mp3
    //if (mode === "single" && text) {
    formData.append("text", text);
    //}

    const response = await fetch(`${BASE_URL}/generate_video`, {
      method: 'POST',
      body: formData
    });

    if (!response.ok) {
      //const errorText = await response.text();
      //console.error("Backend error:", errorText);
      throw new Error("Video generation failed");
    }

    // ✅ Parse JSON instead of blob
    {/*const result = await response.json();
  if (!result.video_url) {
    throw new Error("No video_url returned from backend");
  }

  // ✅ Return the actual URL from backend
  return `${BASE_URL}${result.video_url}`; */}
    const data = await response.json();
    return data.video_url; // ✅ Now returns full URL
  }
  catch (error) {
    console.error("Error generating video:", error);
    throw error;
  }

};










{/* video generated but text is not showing
export const generateVideo = async (mode, audioPath, text) => {
  const formData = new FormData();
  formData.append("mode", mode);
  formData.append("audio_path", audioPath);
  formData.append("text", text);  // text is optional for "scene" mode

  const response = await fetch('/generate_video', {
    method: 'POST',
    body: formData, // ✅ NOT JSON
  });

  if (!response.ok) throw new Error('Video generation failed');
  const blob = await response.blob();
  return URL.createObjectURL(blob);
};
 */}
